export class CountryModel {
    CODIGO?: string;
    TITULO?: string;

    constructor() { }
}
